// Namespaced + versioned so future schema changes (e.g. adding fields like
// timestamp) can bump the suffix without colliding with stale localStorage
// payloads from earlier builds.
export const STORAGE_KEY = 'airspace.search.recents.v1';

// Matches the FAA drawer v2 spec — "Recent" list caps at 5 entries before
// oldest starts rolling off.
export const MAX_RECENTS = 5;
